import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import ControlP from '../../../atoms/control/ControlP';

const MetaPixelCreateControl = function MetaPixelCreateControl({
    name, label, placeholder, value, onChange, isCheckbox, prefix,
}) {
    return (
        <ControlP key={`${name}-control`}>
            <div className={styles.control}>
                <div className={styles.column}>
                    {label}
                </div>
                <div className={styles.column}>
                    <div className={styles['input-container']}>
                        {prefix}
                        <input
                            onChange={onChange}
                            className={isCheckbox ? 'checkbox' : 'input'}
                            name={name}
                            placeholder={placeholder}
                            type={isCheckbox ? 'checkbox' : 'text'}
                            value={value}
                        />
                    </div>
                </div>
            </div>
        </ControlP>
    );
};

MetaPixelCreateControl.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    onChange: PropTypes.func.isRequired,
    isCheckbox: PropTypes.bool,
    prefix: PropTypes.node,
};

MetaPixelCreateControl.defaultProps = {
    prefix: null,
    label: '',
    name: '',
    placeholder: '',
    isCheckbox: false,
};

export default MetaPixelCreateControl;
